import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=4bc0306f&scoped=true&"
import script from "./Priority.vue?vue&type=script&lang=js&"
export * from "./Priority.vue?vue&type=script&lang=js&"
import style0 from "./Priority.vue?vue&type=style&index=0&id=4bc0306f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc0306f",
  null
  
)

export default component.exports